import { getLootdropData } from '@helpers/drops';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';
import * as Shared from '@shared/lib';

export class ItemDropObject {
  private _image: Phaser.GameObjects.Image;

  private _glowTween: Phaser.Tweens.Tween;
  private _glow: Phaser.GameObjects.Image;
  private scene: Game = Game.current;

  constructor(
    public x: number,
    public y: number,
    public lootDrop: Shared.LootDropMessage
  ) {
    this._placeItem();
  }

  public setDepth(depth: number) {
    this._image.setDepth(depth);
    this._glow.setDepth(depth - 1);
  }

  private _placeItem() {
    this.scene.items.push(this);

    const imageKey = getLootdropData(this.lootDrop)?.dropImage;
    this._image = this.scene.add.image(this.x, this.y, 'sprites', imageKey)
      .setDepth(DEPTH.ITEM_DROP)
      .setTint(0xCCCCCC)
      .setInteractive();
    const scale = Math.min(32 / this._image.displayWidth, 32 / this._image.displayHeight);
    this._image.setScale(scale);

    this._glow = this.scene.add.image(this.x, this.y, 'sprites', 'glow')
      .setDepth(DEPTH.ITEM_DROP - 1)
      .setAlpha(0.05);
    this._glow.setScale(96 / this._glow.displayWidth);

    this._glowTween = this.scene.tweens.add({
      targets: this._glow,
      scale: '-=0.02',
      yoyo: true,
      repeat: -1,
    });

    this.scene.tweens.add({
      onComplete: () => {
        this._collectItem();
      },
      x: '+=' + (Math.random() * 100 - 50),
      y: '+=' + (Math.random() * 100 - 50),
      targets: [this._image, this._glow],
      ease: 'Power2',
      duration: 500
    });
  }

  private _collectItem() {
    const camera = this.scene.cameras.main;

    this.scene.tweens.add({
      targets: [this._image, this._glow],
      onComplete: () => this._destroy(),
      y: camera.displayHeight + 24,
      x: camera.displayWidth / 2,
      ease: 'Power2',
      duration: 500,
      scale: 0.025,
    });
  }

  private _destroy() {
    this._glowTween.stop();
    this._image.destroy();
    this._glow.destroy();
    this.scene.items = this.scene.items.filter(i => i !== this);

    this.scene.itemCollectInfoSystem.itemCollected(this.lootDrop);
  }
}